import { StateSchema } from 'app/providers/StoreProvider';

import { Vendor } from '../types/VendorsSchema';

export const getPropertyVendorsList = (state: StateSchema) =>
    state.vendors?.vendorsList;

export const getPropertyVendorsMap = (
    state: StateSchema,
): Record<string, Vendor> | null | undefined => state.vendors?.vendorsMap;

export const getAllVendorsList = (state: StateSchema) =>
    state.vendors?.allVendorsList;

export const getaAllSpecialtiesList = (state: StateSchema) =>
    state.vendors?.allSpecialties;

export const getCurrentVendorToAdd = (state: StateSchema) =>
    state.vendors?.currentVendorToAdd;

export const getIsShowVendorToAddDialog = (state: StateSchema) =>
    state.vendors?.isShowVendorToAddDialog;

export const getIsLoadingVendorsList = (state: StateSchema) =>
    state.vendors?.dataIsLoading;
